/**
 * Remove the helper function after all uTag events are migrated to the TealiumEvent setup.
 */
export function mediaOffsetValue(time?: number) {
  return time ? Math.floor(time) : 0;
}

export function convertUtcToUnix(utcTime: string) {
  return Date.parse(utcTime) / 1000;
}

/**
 * The method is used to place item in the first place of a string array.
 * Since this method is using anti-pattern and it changes the array prop directly,
 * we should be careful when using it.
 */
export function firstInOrder(items: string[], item: string) {
  const itemIndex = items.indexOf(item);
  if (itemIndex !== -1) {
    items.splice(itemIndex, 1);
    items.unshift(item);
  }
}
